import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";
const Home = () => import("/src/views/Home.vue");
const ResetPassword = () => import("/src/views/PasswordReset.vue");
const UnsubscribeEmails = () => import("/src/views/UnsubscribeEmails.vue");
const ChangeEmail = () => import("/src/views/ChangeEmail.vue");

const routes = [
  {
    path: "/reset_password/:token/:id",
    component: ResetPassword,
  },
  {
    path: "/unsubscribe/:id",
    component: UnsubscribeEmails,
  },
  {
    path: "/change_email/:token/:id",
    component: ChangeEmail,
  },
  {
    path: "/auth",
    name: "Auth",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/redeem",
    name: "RedeemCoupon",
    component: () => import("../views/RedeemCoupon.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: Home,
  },
  {
    path: "/auth/google/callback",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/auth/facebook/callback",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/auth/apple/callback",
    component: () => import("../views/Auth.vue"),
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
